
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'newgoodsrecordIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'newgoodsrecord',
				windowName: '模块名称',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
